// KPI sayfaları ortak yönlendirme (M16 T9/T10).
import { useNavigate } from "react-router-dom";
import { useKpiStore } from "../../stores/kpi-store";

/** "Katalogdan Set Oluştur" → katalog sayfası (müşteri bağlamıyla). */
export function useCreateSetNav(): (clientId?: string | null) => void {
  const navigate = useNavigate();
  const clientId = useKpiStore((s) => s.clientId);
  return (id) => {
    const c = id ?? clientId;
    void navigate(c ? `/clients/kpi/katalog?clientId=${c}` : "/clients/kpi/katalog");
  };
}
